import RenderMediaAttachments from './RenderMediaAttachments';

export default RenderMediaAttachments;
